import { z } from "zod";
import { orderGroupIdZodSchema } from "../order-groups/order-group-id";
import { groupReferenceZodObject } from "../payments/group-reference";
import { priceZodSchema } from "../prices/price";
import { translatableZodSchema } from "../translations/translation";
import { orderEventIdZodSchema } from "./order-events/events/_order-event-id";
import { orderIdZodSchema } from "./order-id";

const unpaidItemZodSchema = z.object({
    unpaidItemFor: z.object({
        orderId: orderIdZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        orderEventId: orderEventIdZodSchema,
    }),
    price: priceZodSchema,
    pricePerItem: priceZodSchema,
    title: translatableZodSchema,
    quantity: z.number(),
    group: groupReferenceZodObject.optional(),
    action: z.enum(["ADDED", "REMOVED"]),
});

type UnpaidItem = z.infer<typeof unpaidItemZodSchema>;

export { unpaidItemZodSchema };
export type { UnpaidItem };
